import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, ActivatedRoute } from '@angular/router';
import { filter, map, switchMap } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';
import { CodeInputModule } from 'angular-code-input';
import { LinkApiService } from '../../../../../api/generated/services/LinkApiService';
import { notNullOrUndefined } from '../../../../../shared/utils';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'app-pincode',
    templateUrl: './pincode.component.html',
    styleUrl: './pincode.component.scss',
    standalone: true,
    imports: [CodeInputModule, TranslateModule]
})
export class PincodeComponent implements OnInit {
  loading = false;
  error: string | null = null;
  creator: string | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private linkService: LinkApiService,
    private authService: AuthenticationService,
    private destroyRef: DestroyRef,
    private _snackBar: MatSnackBar,
    private translate: TranslateService,
    private languageService: LanguageService
  ) {
  }

  ngOnInit(): void {
    this.authService.invalidateAccessToken();
    this.navigateOnAuthenticated();
    this.setStatus();
    this.getCreator();

    this.route.paramMap.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(params => {
      const language = params.get('language');
      if (language) {
        console.log('Setting language to', language);
        //this.translate.use(language);
        this.languageService.setLanguage(language);
        sessionStorage.setItem("language", language);
      }
      else if(sessionStorage.getItem("language")) {
        this.languageService.setLanguage(sessionStorage.getItem("language")!);
      }
    });   
  }

  navigateOnAuthenticated() {
    this.authService.authenticatedUser$
      .pipe(
        filter(notNullOrUndefined),
        map(user => {
          if (user.canDownload) {
            return ['/', 'download'];
          }
          if (user.canUpload) {
            return ['/', 'upload'];
          }

          throw new Error('User has unknown rights.')
        }),
        switchMap(route => this.router.navigate(route)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  onCodeCompleted(code: string) {
    this.validate(code);
  }

  getCreator(){
    this.route.params
      .pipe(
        map(params => params['uniqueToken'] as string | undefined),
        filter(notNullOrUndefined),
        switchMap(uniqueToken => this.linkService.getApiV10Creator(uniqueToken))
      )
      .subscribe({
        next: (response) => {
          this.creator = response.creator;
        },
        error: () => {
          this.creator = null;
        }
      });
  }

  setStatus(){
    this.route.params
      .pipe(
        map(params => params['uniqueToken'] as string | undefined),
        filter(notNullOrUndefined),
        switchMap(uniqueToken => this.linkService.postApiV10Status({ token: uniqueToken, status: 'Opened'}))
      )
        .subscribe({
          error: () => {
            //this.error = 'De status kon niet worden bijgewerkt.';
          }
        });
  }

  validate(pinCode: string) {
    this.loading = true;

    this.route.params
      .pipe(
        map(params => params['uniqueToken'] as string | undefined),
        filter(notNullOrUndefined),
        switchMap(uniqueToken => this.linkService.postApiV10Validate({ token: uniqueToken, pinCode }))
      )
      .subscribe({
        next: (response) => {
          this.authService.setAccessToken(response.accessToken);
        },
        error: () => {
          this.translate.get('error.pincode').subscribe((tranlation: string) => {
            //this.error = tranlations['error.pincode'];
            this.translate.get('close').subscribe((close: string) => {
            this.openSnackBar(tranlation, close);
            });
          });
         
        },
        complete: () => {
          this.loading = false;
        }
      });
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, { 
      duration: 5000, 
      panelClass: ['mat-warn'] 
    })
  }
}
